var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"mt-0",attrs:{"hide-details":"auto","label":_vm.question.name,"error":!!_vm.errors.length,"error-messages":_vm.errors,"readonly":_vm.readonly},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }